'use client'

import { useState, useEffect } from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Cell,
    PieChart,
    Pie
} from 'recharts';

export function DashboardCharts({ inventoryData }: { inventoryData: any[] }) {
    const COLORS = ['#22c55e', '#eab308', '#ef4444'];
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

            {/* Gráfico de Barras de Inventario */}
            <div className="bg-white dark:bg-zinc-900 p-6 rounded-2xl border border-zinc-200 dark:border-zinc-800 shadow-sm">
                <h3 className="text-lg font-bold text-zinc-900 dark:text-white mb-4 text-center">Estado del Inventario</h3>
                <div className="h-[300px] w-full">
                    {isMounted ? (
                        <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={0}>
                            <PieChart>
                                <Pie
                                    data={inventoryData}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={60}
                                    outerRadius={100}
                                    paddingAngle={5}
                                    dataKey="value"
                                >
                                    {inventoryData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                                <Tooltip
                                    contentStyle={{ backgroundColor: '#18181b', border: 'none', borderRadius: '8px', color: '#fff' }}
                                    itemStyle={{ color: '#fff' }}
                                />
                            </PieChart>
                        </ResponsiveContainer>
                    ) : (
                        <div className="w-full h-full flex items-center justify-center">
                            <span className="text-zinc-400 text-sm animate-pulse">Cargando gráfico...</span>
                        </div>
                    )}
                </div>
                <div className="flex justify-center gap-6 mt-4">
                    {inventoryData.map((item, index) => (
                        <div key={item.name} className="flex items-center gap-2">
                            <div className="w-3 h-3 rounded-full" style={{ backgroundColor: COLORS[index] }}></div>
                            <span className="text-xs text-zinc-500 dark:text-zinc-400 font-medium">{item.name}</span>
                        </div>
                    ))}
                </div>
            </div>

            {/* Mensaje de bienvenida visual */}
            <div className="bg-gradient-to-br from-blue-600 to-indigo-700 p-8 rounded-2xl shadow-xl flex flex-col justify-center text-white relative overflow-hidden">
                <div className="absolute top-0 right-0 p-4 opacity-10">
                    <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="100" cy="100" r="100" fill="white" />
                    </svg>
                </div>
                <h2 className="text-3xl font-black mb-2 relative z-10 text-white">¡Listo para despegar!</h2>
                <p className="text-blue-100 mb-6 relative z-10">
                    Ya tienes el control total de tus proyectos inmobiliarios. Registra parcelas, gestiona clientes y monitorea tus ingresos en tiempo real.
                </p>
                <div className="flex gap-4 relative z-10">
                    <div className="p-3 bg-white/10 rounded-lg backdrop-blur-sm border border-white/20">
                        <p className="text-xs opacity-70">Sistema</p>
                        <p className="font-bold">v1.2 Active</p>
                    </div>
                    <div className="p-3 bg-white/10 rounded-lg backdrop-blur-sm border border-white/20">
                        <p className="text-xs opacity-70">Base de Datos</p>
                        <p className="font-bold">Supabase Cloud</p>
                    </div>
                </div>
            </div>

        </div>
    );
}
